'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _class, _class2, _temp;

var _reactRedux = require('react-redux');

var _auth = require('redux/actions/auth');

var _modal_type = require('redux/actions/modal_type');

var _headInfo = require('redux/actions/headInfo');

var _components2 = require('components');

var _helpers = require('helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    AuthHeader: {
        displayName: 'AuthHeader'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/components/Auth/AuthHeader.jsx',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var AuthHeader = _wrapComponent('AuthHeader')((_dec = (0, _reactRedux.connect)(function (state) {
    return {
        setting: state.setting,
        user: state.auth.user,
        lang: state.lang
    };
}, {
    hideSideMenu: _headInfo.hideSideMenu,
    logout: _auth.logout,
    showModalAuth: _modal_type.showModalAuth
}), _dec(_class = (_temp = _class2 = function (_Component) {
    (0, _inherits3.default)(AuthHeader, _Component);

    function AuthHeader(props) {
        (0, _classCallCheck3.default)(this, AuthHeader);

        var _this = (0, _possibleConstructorReturn3.default)(this, (AuthHeader.__proto__ || (0, _getPrototypeOf2.default)(AuthHeader)).call(this, props));

        _this.closeSideMenu = function () {
            _this.props.hideSideMenu();
        };

        return _this;
    }

    (0, _createClass3.default)(AuthHeader, [{
        key: 'render',
        value: function render() {
            var View = _helpers.ThemeHelper.getViewForComponent('AuthHeader', null, { folderName: 'Auth' });

            return _react3.default.createElement(View, {
                closeSideMenu: this.closeSideMenu,
                logout: this.props.logout,
                setting: this.props.setting,
                show: this.props.showModalAuth,
                user: this.props.user,
                lang: this.props.lang
            });
        }
    }]);
    return AuthHeader;
}(_react2.Component), _class2.propTypes = {
    hideSideMenu: _react2.PropTypes.func.isRequired,
    logout: _react2.PropTypes.func.isRequired,
    setting: _react2.PropTypes.object.isRequired,
    showModalAuth: _react2.PropTypes.func.isRequired,
    user: _react2.PropTypes.object,
    lang: _react2.PropTypes.object
}, _temp)) || _class));

exports.default = AuthHeader;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Auth/AuthHeader.jsx
// module id = 1604
// module chunks = 0